import { render, staticRenderFns } from "./ZimbraPackagePrices.vue?vue&type=template&id=8ee8974e&"
import script from "./ZimbraPackagePrices.vue?vue&type=script&lang=js&"
export * from "./ZimbraPackagePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports